<app-breadcrumb
  [title]="'Usuarios App'"
  [items]="['Usuarios']"
  [active_item]="'Usuarios App'"
>
</app-breadcrumb>


<div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-list me-2"></i>
      <h5 class="mb-0">Datos de Cotización</h5>
    </div>
    <div class="card-body custom-datatable noscroll">
      <div class="row mb-3">
        <div class="col-4 offset-8">
          <div class="input-group">
            <input
                type="text"
                class="form-control"
                placeholder="Buscar"
                [(ngModel)]="searchText"
                (input)="filterByMultipleFields()"
              />
            <span class="input-group-text">
              <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
            </span>
          </div>
        </div>
      </div>
      <div class="custom-datatable table-responsive">
        <table class="table table-responsive border border-secondary table-hover table-striped my-3">
          <thead>
            <tr>
              <th scope="col" sortable="Usuarios" (sort)="onSort($event)" class="text-primary border border-secondary text-center">USUARIOS</th>
              <th scope="col" sortable="Password" (sort)="onSort($event)" class="text-primary border border-secondary text-center">PASSWORD</th>
              <th scope="col" sortable="Fecha" (sort)="onSort($event)" class="text-primary border border-secondary text-center">ÚLTIMA FECHA DE INGRESO</th>
              
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredTableItems">
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Usuarios" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Password" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Fecha" [term]="service.searchTerm"></ngb-highlight>
              </td>
             
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between mt-3">
          <select class="form-select" style="width: 150px" name="pageSize">
            <option [ngValue]="2">2 items per page</option>
            <option [ngValue]="4">4 items per page</option>
            <option [ngValue]="6">6 items per page</option>
          </select>
          <ngb-pagination class="ms-3" [collectionSize]="(total$ | async)!" ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>